import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import { Card, Row, Col, ProgressBar, Button, Form } from "react-bootstrap";
import { FaFlask, FaVirus, FaSearch, FaBlog, FaCalculator } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const UserDashboard = () => {
  const [user, setUser] = useState(null);
  const [remainingDays, setRemainingDays] = useState(null);

  // Kullanıcı Bilgisi
  useEffect(() => {
    const token = localStorage.getItem("token");

    api
      .get("/auth/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setUser(res.data);

        if (res.data.isApproved && res.data.approvedAt) {
          const approved = new Date(res.data.approvedAt);
          const now = new Date();

          const diffMs = 365 * 24 * 60 * 60 * 1000 - (now - approved);
          const days = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));

          setRemainingDays(days);
        }
      });
  }, []);

  return (
    <UserLayout>

<style>
{`
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

.suggestion-item:hover {
  background: #E7F5F2;
}
`}
</style>

      {/* Hoş geldin */}
      <h2 className="fw-bold mb-4" style={{ color: "#2D8A7A" }}>
        👋 Hoş geldin, {user?.name}
      </h2>

      {/* Lisans durumu */}
      {user?.isApproved && (
        <Card className="p-3 shadow-sm mb-4">
          <h5 className="fw-bold">Lisans Durumu</h5>
          <p className="mb-1">
            Başlangıç: {new Date(user.approvedAt).toLocaleDateString("tr-TR")}
          </p>
          <p className="fw-semibold" style={{ color: "#2D8A7A" }}>
            Kalan Süre: {remainingDays} gün
          </p>

          <ProgressBar
            now={(remainingDays / 365) * 100}
            variant={remainingDays < 30 ? "danger" : "success"}
            className="mb-2"
          />

          {remainingDays < 30 && (
            <Button href="/odeme" variant="warning" className="fw-bold">
              Lisansı Yenile
            </Button>
          )}
        </Card>
      )}

      {!user?.isApproved && (
        <Card className="p-3 shadow-sm mb-4 bg-warning bg-opacity-25">
          <h5 className="fw-bold text-danger">Ödeme Bekleniyor</h5>
          <p>Platformu kullanabilmek için ödemenizi tamamlayın.</p>
          <Button href="/odeme" variant="warning" className="fw-bold">
            Ödeme Yap
          </Button>
        </Card>
      )}

      {/* Hızlı erişim */}
      <Row className="g-4 mt-2">
        <Col md={4}>
          <Card className="p-4 shadow-sm text-center hover-scale">
            <FaFlask size={40} color="#2D8A7A" />
            <h5 className="mt-3 fw-bold">Majistral Formüller</h5>
            <p className="text-muted">Tüm formülleri görüntüleyin.</p>
            <Button href="/panel/formulas" variant="primary">
              Aç
            </Button>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-4 shadow-sm text-center hover-scale">
            <FaVirus size={40} color="#2D8A7A" />
            <h5 className="mt-3 fw-bold">Hastalıklar</h5>
            <p className="text-muted">Klinik bilgi modülü.</p>
            <Button href="/panel/diseases" variant="primary">
              Aç
            </Button>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-4 shadow-sm text-center hover-scale">
            <FaBlog size={40} color="#2D8A7A" />
            <h5 className="mt-3 fw-bold">Blog</h5>
            <p className="text-muted">Blog yazıları.</p>
            <Button href="/blogs" variant="primary">
              Aç
            </Button>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-4 shadow-sm text-center hover-scale">
            <FaCalculator size={40} color="#2D8A7A" />
            <h5 className="mt-3 fw-bold">Alkol Hesaplama</h5>
            <p className="text-muted">Hızlı hesaplama aracı.</p>
            <Button href="/panel/alcohol" variant="primary">
              Aç
            </Button>
          </Card>
        </Col>
      </Row>
    </UserLayout>
  );
};

export default UserDashboard;
